<template>
  <div
    class="ak-modal__body"
    :class="{
      'ak-modal__body--paddingless': paddingless,
      'ak-modal__body--outer-scroll': outerScroll,
      'ak-modal__body--flex': flexBody,
    }"
  >
    <slot />
  </div>
</template>

<script>
import { defineComponent, computed, inject } from 'vue'

export default defineComponent({
  name: 'AkModalBody',

  setup() {
    const modal = inject('akModal')
    const paddingless = computed(() => modal && modal.paddingless)
    const outerScroll = computed(() => modal && modal.paddingless)
    const flexBody = computed(() => modal && modal.paddingless)
    return {
      paddingless,
      outerScroll,
      flexBody,
    }
  },
})
</script>
